var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { Icon } from 'elements';
class CheckBox extends Component {
    render() {
        const _a = this.props, { label, checked, onChange } = _a, props = __rest(_a, ["label", "checked", "onChange"]);
        return (React.createElement(Label, Object.assign({}, props, { onClick: () => onChange(!checked) }),
            React.createElement(Box, null, checked ? React.createElement(Icon, { style: {
                    padding: 0,
                }, name: "tick" }) : null),
            React.createElement(Span, { style: { textTransform: 'unset' } }, label)));
    }
}
export default CheckBox;
const Label = cxs('label')({
    display: 'block',
    padding: Theme.size.space[1]
});
const Box = cxs('div')({
    display: 'inline-block',
    width: Theme.fontSize.big,
    height: Theme.fontSize.big,
    marginRight: Theme.size.space[1],
    verticalAlign: 'sub',
    border: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    '> icon': {
        padding: 0
    }
});
const Span = cxs('span')({
    display: 'inline-block',
    verticalAlign: 'initial',
});



//////////////////
// WEBPACK FOOTER
// ./src/elements/CheckBox.tsx
// module id = 370
// module chunks = 0